import { render } from "./IconDropDown.vue?vue&type=template&id=e11ccc64"
const script = {}
script.render = render

export default script